import type { CustomField } from '@kitopi-com/customer-auth';
import { useTranslation } from 'react-i18next';

export const useCustomFields = (): CustomField[] => {
  const { t } = useTranslation('wifi');

  return [
    {
      id: 'name',
      type: 'text',
      label: t('customFields.name.label'),
      placeholder: t('customFields.name.placeholder'),
      required: true,
      position: 'before-phone',
      validation: {
        minLength: 2,
        maxLength: 50,
      },
      errorMessages: {
        required: t('customFields.name.errorMessages.required'),
        minLength: t('customFields.name.errorMessages.minLength'),
      },
    },
    {
      id: 'communicationEmail',
      type: 'email',
      label: t('customFields.communicationEmail.label'),
      placeholder: t('customFields.communicationEmail.placeholder'),
      required: true,
      position: 'after-phone',
      validation: {
        pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      },
    },
  ];
};
